import React from "react";

// Real Dhadda Motion Pictures logo (gold D with film reel + wordmark)
// Stored at /public/dhadda-logo.png
const LOGO_SRC = "/dhadda-logo.png";

export const Logo = ({ size = 48, withText = false, className = "", variant = "full" }) => {
  // variant: "mark" = just the icon | "full" = with text | "wordmark-hidden" = icon only via image
  // The provided PNG already contains the wordmark. We crop via CSS object-fit
  // for icon-only usage, or show the full logo when withText.
  if (withText) {
    return (
      <div className={`inline-flex items-center ${className}`} data-testid="brand-logo">
        <img
          src={LOGO_SRC}
          alt="Dhadda Motion Pictures"
          style={{ height: size, width: "auto" }}
          className="object-contain"
          draggable={false}
        />
      </div>
    );
  }

  // Icon-only crop: show top portion (the D mark), hide wordmark using container clip
  return (
    <div
      className={`inline-flex overflow-hidden ${className}`}
      style={{ width: size, height: size }}
      data-testid="brand-logo-mark"
    >
      <img
        src={LOGO_SRC}
        alt="Dhadda Motion Pictures"
        style={{
          width: size,
          height: size * 1.25,
          objectFit: "cover",
          objectPosition: "center top",
        }}
        draggable={false}
      />
    </div>
  );
};

export default Logo;
